import React from 'react';
import styled, { css } from 'styled-components';

const PageWrapper = styled.div`
  /* position: absolute; */
  /* left: 0; */
  /* top: 0; */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  width: 100%;
  height: 100%;
  min-height: 100vh;
  /* border: 1px solid red; */

  @media only screen and (max-width: ${props => props.theme.mq.large}) {
    min-height: calc(100vh - 145px);
  }

  ${props =>
    props.fullheight &&
    css`
      @media only screen and (max-width: ${props => props.theme.mq.large}) {
        min-height: 100vh;
        /* border: 1px solid red; */
      }
    `};
`;

const BasePage = props => (
  <PageWrapper {...props}>{props.children}</PageWrapper>
);

BasePage.propTypes = {};

export default BasePage;
